import React, { useContext } from 'react';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FincenContext, IEvent } from './context';
import { Btn } from 'components/btn/Btn';
import { FincenFlowState } from './types';

export const RequiresInformationSubmissionView = () => {
    return (
        <div className="border rounded-md p-5 shadow-md mb-5 border-error">
            <Title />
            <Content />
        </div>
    );
};

const Title = () => (
    <div className="text-error mb-2 font-semibold text-xl">
        <FontAwesomeIcon icon={faExclamationCircle} size="lg" className="mr-2" />
        Additional information needed
    </div>
);

const Content = () => {
    const { dispatch, enterInfoUrl, moreInfoUrl } = useContext(FincenContext);

    const changeOrder = () => {
        (dispatch as React.Dispatch<IEvent>)({
            name: 'SET_FINCEN_FLOW_STATE',
            payload: FincenFlowState.WILL_EDIT_CART,
        });
    };

    const sendToFincenForm = () => {
        if (enterInfoUrl) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).location.href = `${enterInfoUrl}?returnUrl=${window.location.href}`;
        }
    };

    return (
        <div className="font-semibold text-xs text-grey-2">
            <p>
                This order will result in you purchasing more than $10,000 worth of gift cards in
                the past 24 hours. We are required by the Financial Crimes Enforcement Network
                (FinCEN) to gather additional information before completing your purchase. We
                appreciate your patience as we work to comply with all federal regulations.
            </p>

            <p className="mt-5">
                For more information: <a href={moreInfoUrl}>RaiseRight FinCEN Policy</a>
            </p>

            <div className="mt-14 sm:mt-10 flex gap-5 flex-col-reverse sm:flex-row sm:justify-end">
                <Btn className="mx-auto sm:m-0" onClick={changeOrder} isSecondary>
                    Change My Order
                </Btn>
                <Btn onClick={sendToFincenForm}>Fill Out FinCEN Form</Btn>
            </div>
        </div>
    );
};
